import React from 'react'

const Break = () => {
  return (
    <div className='clear-both opacity-50'>
        <div className='relative align-top'>
            <section className="bg-break-banner-mobile md:bg-break-banner min-h-screen static bg-cover bg-center bg-no-repeat opacity-50"></section>
        </div>
    </div>
  )
}

export default Break